import { Controller } from '@hotwired/stimulus'

export default class ModalController extends Controller {
  static targets = ["form"]
  static values = {
    show: Boolean
  }

  connect() {
    this.modal = new bootstrap.Modal(this.element);
    if (this.hasShowValue && this.showValue === true) {
      this.modal.show();
    }
  }

  submit(event) {
    if (this.hasFormTarget) this.formTarget.submit();
  }
}
